module.exports = __webpack_public_path__ + "img/metro_L10N.e1067e37.svg";